<button
  [ngClass]="getButtonClasses()"
  (click)="buttonAction.emit($event)"
  type="button"
  class="ib m-block btn"
  data-dgat="download-button-8e2"
>
  <div class="l_flexbar gap-full-half">
    <df-icon icon="arrow-down-tray"></df-icon>
    <div>{{ label }}</div>
  </div>
</button>
